import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";

import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';
import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';

import { GroupementTLR } from '../entities/groupement-tlr.entity';

@Injectable({ providedIn: 'root' })
export class GroupementService {
	private path: string;

	private groupementTLRSubService!: BasicDataSubService<GroupementTLR>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(CachedDataSurveyService) private cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: GroupementService //
	) {
		if (previousInstance) {
			throw new Error(
				'GroupementParcService is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		
		// Combiner les notifications de changement de Groupement et GroupementParc car un groupement de parc dans la partie cliente est la combinaison de ces deux entites Java
		let dataChanged$ = this.cachedDataSurveyService.getChangeNotification("Groupement");
		this.groupementTLRSubService = new BasicDataSubService<GroupementTLR>(httpClient, this.path + 'groupementParcs?format=TLR', dataChanged$);
	}
	
	// Methode permettant le chargement de tous les groupements en format TLR
	public getGroupementTLRList = () => this.groupementTLRSubService.getList();

	// Methodes permettant le chargement de tous les parcs, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getGroupementTLRMapById = () => this.groupementTLRSubService.getMapById();
	public getGroupementTLRById = (id: number) => this.groupementTLRSubService.getKnownById(id, "GroupementTLR")
	public getGroupementTLRMapByAntenne = () => this.groupementTLRSubService.getMapByForeignKey("byAntenne", (groupement: GroupementTLR) => groupement.antenneId);
	public getGroupementTLRByAntenne = (id: number) => this.groupementTLRSubService.getByForeignKey("byAntenne", (groupement: GroupementTLR) => groupement.antenneId, id);
}